import styled from "styled-components";

export const Container = styled.div`
  margin-left: 12%;
  display: flex;
  flex: 1;
  flex-direction: ${props => props.flexDirection || "row"};
  @media (max-width: 1200px) {
    flex-direction: column;
  }
  @media (max-width: 600px) {
    margin: 0px;
    flex-direction: column;
  }
`;
